import React from 'react'
import { Role } from '@contrast-security-inc/base-types'
import { RowActionList } from '../../../legacy-design-system/grid'
import { DeleteByRouteHashesAction } from './delete/delete-by-route-hashes-action'
import { Route } from '../../../graphql/schema/types/route'
import { ExcludeByRouteHashesAction } from './exclude/exclude-by-route-hashes-action'
import { IncludeByRouteHashesAction } from './include/include-by-route-hashes-action'
import { useQueryClient } from 'react-query'
import { routeMutationOnSuccess } from './shared'

export interface RouteActionProps {
  readonly organizationUuid: string
  readonly applicationUuid: string
  readonly rowData: Route
  readonly applicationRole: Role
  readonly agentSessionId?: string[]
}

export function RouteRowActionList({
  onSuccess,
  organizationUuid,
  applicationUuid,
  rowData: { hash, status },
  applicationRole,
  agentSessionId
}: RouteActionProps & {
  readonly onSuccess: () => void
}) {
  const queryClient = useQueryClient()

  function mutationOnSuccess() {
    return routeMutationOnSuccess({ queryClient, onSuccess })
  }

  return (
    <RowActionList>
      {status !== 'EXCLUDED' && (
        <ExcludeByRouteHashesAction
          applicationRole={applicationRole}
          organizationUuid={organizationUuid}
          applicationUuid={applicationUuid}
          routeHashes={[hash]}
          onSuccess={mutationOnSuccess}
          pendoId="exclude_single_route"
          agentSessionId={agentSessionId}
        />
      )}
      {status === 'EXCLUDED' && (
        <IncludeByRouteHashesAction
          applicationRole={applicationRole}
          organizationUuid={organizationUuid}
          applicationUuid={applicationUuid}
          routeHashes={[hash]}
          onSuccess={mutationOnSuccess}
        />
      )}
      {
        <DeleteByRouteHashesAction
          applicationRole={applicationRole}
          organizationUuid={organizationUuid}
          applicationUuid={applicationUuid}
          routeHashes={[hash]}
          onSuccess={mutationOnSuccess}
        />
      }
    </RowActionList>
  )
}
